import React from 'react';
import PropTypes from 'prop-types';

import { FontSize, FontWeight } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import Text, { TextTags } from '../../atoms/text/text';
import { dateFormat } from '../../../utils/times';
import Dot from '../../atoms/dot/dot';
import t from '../../../labels/labelling-utils';

import './last-update.scss';

export interface ILastUpdate extends IComponent {
  showDot?: boolean;
  isoTimestamp: string;
}

const LAST_UPDATE_TAG: TextTags = 'p';

const LAST_UPDATE_FONT_SIZE: FontSize = '12';
const LAST_UPDATE_FONT_WEIGHT: FontWeight = '400';

const classNames = (): IClassNames =>
  makeClassNames({
    lastUpdateWrapper: 'last-update--wrapper',
    lastUpdate: 'last-update',
    lastUpdateDate: 'last-update__date',
  });

const getFormattedIsoTimestamp = (isoTimestamp: string) => {
  const dateDMY = dateFormat({ date: isoTimestamp, format: 'DD MMMM YYYY' });
  const dateHM = dateFormat({ date: isoTimestamp, format: 'hh:mm' });

  return (
    <React.Fragment>
      <span>{dateDMY}</span> - {t('titles-labels.hour')} {dateHM}
    </React.Fragment>
  );
};

const LastUpdate: React.FC<ILastUpdate> = ({ showDot = true, isoTimestamp }) => {
  const cn = classNames();

  const dateTime = isoTimestamp ? getFormattedIsoTimestamp(isoTimestamp) : '-';

  return (
    <div className={cn.lastUpdateWrapper}>
      {showDot && <Dot isBlinking />}
      <Text
        className={cn.lastUpdate}
        fontSize={LAST_UPDATE_FONT_SIZE}
        fontWeight={LAST_UPDATE_FONT_WEIGHT}
        tag={LAST_UPDATE_TAG}
      >
        <span>{t('lastUpdate.last.update')}:</span> <span className={cn.lastUpdateDate}>{dateTime}</span>
      </Text>
    </div>
  );
};

LastUpdate.propTypes = {
  isoTimestamp: PropTypes.string.isRequired,
  showDot: PropTypes.bool,
};

export default LastUpdate;
